import PropTypes from 'prop-types';
import React from 'react';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { CoverImage } from 'javascripts/components/cover_image';
import { Modal } from 'javascripts/components/modal';

import styles from 'stylesheets/components/full_shopping_cart_modal';

export function FullShoppingCartModal({ audiobook, isOpen, onRequestClose, showWishlistMessage }) {
  const wishlistMessage = showWishlistMessage ? (
    <span>
      We added this book to{' '}
      <a className={styles.wishlistLink} href='/wishlist'>
        your wishlist
      </a>{' '}
      instead.
    </span>
  ) : null;

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <div className={styles.fullShoppingCartModal}>
        <h1 className={styles.heading}>Your Shopping Cart is Full</h1>
        <p className={styles.maxItemsMessage}>
          Shopping carts are limited to <strong>25 items</strong> at a time.
          <br />
          {wishlistMessage}
        </p>

        <div className={styles.coverImageContainer}>
          <CoverImage bookTitle={audiobook.displayTitle} coverUrl={audiobook.coverUrl} defer={false} />
        </div>

        <div className={styles.buttons}>
          <ChirpButton displayStyle='yellow' label='Edit Shopping Cart' href='/shopping_cart' />
          <ChirpButton
            displayType='link'
            label='Or buy just this one book now'
            href={audiobook.currentProduct.purchaseUrl}
          />
        </div>
      </div>
    </Modal>
  );
}

FullShoppingCartModal.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  showWishlistMessage: PropTypes.bool,
};

FullShoppingCartModal.defaultProps = {
  onRequestClose: _.noop,
  showWishlistMessage: true,
};
